import MultiMetricCard from './MultiMetricCard'
import React from 'react'

export default function EconomyMetrics({ economyStats, loading }) {

	const metrics = [
		{
			icon: 'fa-money-bill-wave',
			color: 'text-success',
			value: economyStats ? new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK', minimumFractionDigits: 0 }).format(economyStats.stat_income_current) : '...',
			label: 'Nuvarande MRR',
			tooltip: 'Nuvarande MRR',
			small: true
		},
		{
			icon: 'fa-bullseye',
			color: 'text-info',
			value: economyStats ? new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK', minimumFractionDigits: 0 }).format(economyStats.stat_income_max) : '...',
			label: 'Potentiell MRR',
			tooltip: 'Potentiell MRR',
			small: true
		},
		{
			icon: 'fa-chart-pie',
			color: 'text-primary',
			value: `${Math.floor(economyStats?.stat_occupancy_total)}%`,
			label: 'Uthyrningsgrad',
			tooltip: 'Uthyrningsgrad'
		}
	]

	return (
		<MultiMetricCard
			title="Din ekonomi"
			icon="fa fa-money-bill-wave"
			metrics={metrics}
			loading={loading}
		/>
	)
}
